module.exports = __webpack_public_path__ + "static/media/chat.5ea4c8db.png";